import { useState } from 'react';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { FaRegPaperPlane } from 'react-icons/fa';
import { useAuthContext } from '@contexts/auth';
import PaginationRouterContainer from '@components/PaginationRouterContainer';
import Loading from '@components/Loading';
import useGetList from '@hooks/useGetUsersList';
import usePaginationParams from '@hooks/usePaginationParams';

import InviteDialog from './components/InviteDialog';
import UserCard from './components/UserCard';

const User = () => {
  const [showInviteDialog, setShowInviteDialog] = useState(false);

  const { checkIfHasRole } = useAuthContext();

  const {
    getUsers,
    users,
    totalPages,
    loading,
  } = useGetList();

  usePaginationParams({ onParamsChange: getUsers });

  const getCurrentComponent = () => {
    if (loading) return <Loading />;
    
    if (users.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum usuário encontrado.
        </Box>
      );
    }

    return (
      <PaginationRouterContainer
        total={totalPages}
        onPaginationChange={getUsers}
      >
        {users.map((user) => (
          <UserCard
            key={user.id}
            user={user}
            refetch={() => getUsers({})}
          />
        ))}
      </PaginationRouterContainer>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={8}>
        <Heading>Usuários</Heading>
        {checkIfHasRole('CAN_INVITE_USERS') && (
          <Button size="sm" onClick={() => setShowInviteDialog(true)}>
            <FaRegPaperPlane /> Convidar
          </Button>
        )}
      </Flex>

      {getCurrentComponent()}

      {showInviteDialog && (
        <InviteDialog
          handleClose={() => setShowInviteDialog(false)}
        />
      )}
    </Box>
  );
};

export default User;
